import { render, staticRenderFns } from "./QR_Reader.vue?vue&type=template&id=a893b568&scoped=true"
import script from "./QR_Reader.vue?vue&type=script&lang=js"
export * from "./QR_Reader.vue?vue&type=script&lang=js"
import style0 from "./QR_Reader.vue?vue&type=style&index=0&id=a893b568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a893b568",
  null
  
)

export default component.exports